import * as React from 'react';
import styled, { css } from 'styled-components';

type HeadingType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
type ColorType = 'white' | 'black';

interface IHeading {
  className?: string;
  tag: HeadingType;
  center?: boolean;
  color?: ColorType;
  children: any;
}

export const Heading: React.FC<IHeading> = (props) => {
  const color = props.color ? { color: props.color } : {};
  switch (props.tag) {
    case 'h1':
      return (
        <StyledHeadingH1
          center={props.center}
          className={props.className}
          style={color}
        >
          {props.children}
        </StyledHeadingH1>
      );
    case 'h2':
      return (
        <StyledHeadingH2
          center={props.center}
          className={props.className}
          style={color}
        >
          {props.children}
        </StyledHeadingH2>
      );
    case 'h3':
      return (
        <StyledHeadingH3
          center={props.center}
          className={props.className}
          style={color}
        >
          {props.children}
        </StyledHeadingH3>
      );
    case 'h4':
      return (
        <StyledHeadingH4
          center={props.center}
          className={props.className}
          style={color}
        >
          {props.children}
        </StyledHeadingH4>
      );
    case 'h5':
      return (
        <StyledHeadingH5
          center={props.center}
          className={props.className}
          style={color}
        >
          {props.children}
        </StyledHeadingH5>
      );
    case 'h6':
      return (
        <StyledHeadingH6
          center={props.center}
          className={props.className}
          style={color}
        >
          {props.children}
        </StyledHeadingH6>
      );
    default:
      return null;
  }
};

const BaseHeading = css`
  ${(props: any) => (props.center ? 'text-align: center;' : '')};
  ${(props: any) => (props.center ? 'margin: 0 auto 20px auto;' : '')}

  line-height: 1.2;

  &.no-margin {
    margin: 0;
  }
`;

const StyledHeadingH1 = styled.h1<any>`
  ${BaseHeading}

  @media (max-width: 800px) {
    font-size: 1.9rem;
  }
`;

const StyledHeadingH2 = styled.h2<any>`
  ${BaseHeading}
`;

const StyledHeadingH3 = styled.h3<any>`
  ${BaseHeading}
`;

const StyledHeadingH4 = styled.h4<any>`
  ${BaseHeading}
`;

const StyledHeadingH5 = styled.h5<any>`
  ${BaseHeading}
`;

const StyledHeadingH6 = styled.h6<any>`
  ${BaseHeading}
`;
